import { useQuery } from '@tanstack/react-query';

import { meQueryOptions } from '~/lib/auth';
import { departmentsQueryOptions } from '~/lib/departments';

export function useSlugIds(
  orgSlug: string,
  deptSlug?: string
): { orgId: string; deptId: string | undefined } {
  const { data: session } = useQuery(meQueryOptions);
  const { data: deptsData } = useQuery(departmentsQueryOptions);

  const orgId = session?.orgSlug === orgSlug ? session.orgId : '';
  const deptId = deptSlug
    ? (deptsData?.departments.find((d) => d.slug === deptSlug)?.id ?? '')
    : undefined;

  return { orgId, deptId };
}
